import { IsOptional, IsNotEmpty, IsNumber, IsDate } from "class-validator";

import { IIncentiveParamsJuniorAccount } from "./incentive-params-junior-account.interface";

export class IncentiveParamsJuniorAccountDto
  implements IIncentiveParamsJuniorAccount
{
  @IsOptional()
  @IsNumber()
  early_bird_fee?: number;

  @IsOptional()
  @IsDate()
  early_bird_date?: Date;

  @IsNotEmpty()
  @IsNumber()
  fee: number;
}
